import { z } from "zod";

/** Parâmetro de rota `:configId` (id retornado pela API). */
export const whatsappMetaConfigDetailConfigIdSchema = z.string().min(1);

export type TWhatsappMetaConfigDetailConfigId = z.infer<
  typeof whatsappMetaConfigDetailConfigIdSchema
>;
